import React, { Component } from 'react';
import moment from 'moment';
import PropTypes from 'prop-types';
import { Card } from 'antd';
import { connect } from 'react-redux';
import { JobCardInfo, JobSkillList, JobCardMCA } from './components';
import './index.css';
import JOB_CARD_ACTION from './index.action';

class JobCardComponent extends Component {
  onReadMore = (data) => {
    const { dispatch } = this.props;
    const payload = {
      job: data
    };
    dispatch({ type: JOB_CARD_ACTION.JOB_READ_MORE, payload });
  }

  onStartTest = (mcq_name, mcq_id) => {
    const { dispatch } = this.props;
    const payload = {
      mcqId: mcq_id
    };
    dispatch({ type: JOB_CARD_ACTION.JOB_START_TEST, payload });
    const name = mcq_name.replace(' ', '-');
    window.open(`/dashboard/turing_test/${name}/${mcq_id}`, '_self');
  }

  onConsiderMe = (data) => {
    const { dispatch, onConsiderMe, job } = this.props;
    if (onConsiderMe) onConsiderMe(job);
    const payload = {
      jobId: data
    };
    dispatch({ type: JOB_CARD_ACTION.JOB_CONSIDER_ME, payload });
  }

  onBookTI = () => {
    const { dispatch } = this.props;
    const payload = {
      bookTi: true
    };
    dispatch({ type: JOB_CARD_ACTION.JOB_BOOK_TI, payload });
    window.open('/dashboard/technical_interview', '_self');
  }

  timezone = moment.tz.guess();

  render () {
    const { store, job, picked_date, job_status, future_date, showSeniority, showMatchingLink } = this.props;
    const { jobStatuses } = store.jobCard;

    return (
      <Card className="job-parent-card">
        <JobCardInfo
          jobTitle={job.title}
          seniority={job.seniority}
          onReadMore={() => this.onReadMore(job)}
          jobId={job.id}
          showSeniority={showSeniority}
          showMatchingLink={showMatchingLink}
          description={job.description}
        />
        <hr className="job-horizontal-line" />
        {
          !job_status || job_status.toLowerCase() === 'default' || job_status === '' || (jobStatuses.indexOf(job_status.toLowerCase()) < 0)
            ? <JobSkillList skills={job.skills.filter(s => s.linked_mcq_id)} onStartTest={this.onStartTest} />
            : <JobCardMCA
              status={job_status}
              onBookTI={this.onBookTI}
              pickedDate={picked_date && picked_date !== '' ? moment.utc(picked_date).tz(this.timezone).format('MMM D') : null}
              onConsiderMe={this.onConsiderMe}
              jobId={job.id}
              futureDate={future_date && future_date !== '' ? moment.utc(future_date).tz(this.timezone).fromNow() : null}
            />
        }
      </Card>
    );
  }
}

JobCardComponent.propTypes = {
  store: PropTypes.object,
  dispatch: PropTypes.func,
  job: PropTypes.object.isRequired,
  picked_date: PropTypes.string,
  job_status: PropTypes.string,
  future_date: PropTypes.string,
  onConsiderMe: PropTypes.func,
  showSeniority: PropTypes.func,
  showMatchingLink: PropTypes.func
};

const mapStateToProps = (store) => ({ store });
const mapDispatchToProps = (dispatch) => ({ dispatch });

export default connect(mapStateToProps, mapDispatchToProps)(JobCardComponent);
